import { render, staticRenderFns } from "./wallet-brokerage.vue?vue&type=template&id=aad9b3d0&scoped=true&"
import script from "./wallet-brokerage.vue?vue&type=script&lang=js&"
export * from "./wallet-brokerage.vue?vue&type=script&lang=js&"
import style0 from "./wallet-brokerage.vue?vue&type=style&index=0&id=aad9b3d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad9b3d0",
  null
  
)

export default component.exports